import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomExcelMapperComponent } from './custom-excel-mapper.component';

const routes: Routes = [{ path: '', component: CustomExcelMapperComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomExcelMapperRoutingModule { }
